/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/historyImport.scss';

import React, {MouseEventHandler} from 'react';
import {ChangeFunction, Checkbox, CloseButton} from "@dvrd/dvr-controls";
import IDate from '@dvrd/idate';
import {BolmateButton, BolmateInput, BolmateNumberInput, DvrdDatePicker} from "../../controls";

interface Props {
    onChangeImportDate: ChangeFunction<IDate | null>;
    onChangeInvNumPrefix: ChangeFunction<string>;
    onChangeInvNumStart: ChangeFunction<string>;
    onChangeSendEmails: ChangeFunction<boolean>;
    onChangeStartPage: ChangeFunction<number>;
    onSubmit: MouseEventHandler;
    importTillDate: IDate | null;
    invNumPrefix: string;
    invNumStart: string;
    sendEmails: boolean;
    loading: boolean;
    startPage: number;
}

export default function HistoryImport(props: Props) {
    const {
        importTillDate, onChangeImportDate, onChangeInvNumPrefix, invNumPrefix, invNumStart, onChangeSendEmails,
        onChangeInvNumStart, sendEmails, onSubmit, loading, onChangeStartPage, startPage
    } = props;

    function onClearImportDate() {
        onChangeImportDate(null);
    }

    const btnDisabled = !invNumPrefix.length || !invNumStart.length || loading;
    return (
        <section className='history-import'>
            <label className='section-title'>Instellingen</label>
            <div className='settings'>
                <div className='row date'>
                    <label>(Optioneel) Order importeren vanaf</label>
                    <DvrdDatePicker onChange={onChangeImportDate} value={importTillDate} label=''
                                    placeholder='dd-mm-jjjj' dateFormat='DD-MM-YYYY' closeOnChange/>
                    {!!importTillDate && <CloseButton onClick={onClearImportDate}/>}
                </div>
                <BolmateNumberInput onChange={onChangeStartPage} value={startPage} label='Eerste API page' wholeNumbers
                                    asNumber/>
                <div className='row'>
                    <BolmateInput onChange={onChangeInvNumPrefix} value={invNumPrefix}
                                  label='Voorvoegsel factuurnummer'/>
                    <BolmateInput onChange={onChangeInvNumStart} value={invNumStart} label='Start factuurnummer'/>
                </div>
                <Checkbox onCheck={onChangeSendEmails} checked={sendEmails} label='E-mails verzenden'/>
                <BolmateButton onClick={onSubmit} label='Start' disabled={btnDisabled}/>
            </div>
        </section>
    )
}